// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__3h9x4"};